import { render } from "./FooterAdsense.vue?vue&type=template&id=0c0548cd"
import script from "./FooterAdsense.vue?vue&type=script&lang=js"
export * from "./FooterAdsense.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__